<template>
  <v-card elevation="0">
    <v-tabs class="mt-4" background-color="transparent" color="basil" grow fixed-tabs>
      <v-tab class="slider" value="option-1" centered style="pointer-events: none;">
        {{ $t('Delivery.ClientOrders.ClientOrderInfo') }}
      </v-tab>
    </v-tabs>
    <v-divider class="mb-4"></v-divider>
    <div v-if="clientOrder" class="row ma-4" style="width: 70%; justify-self: center;">
      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0"> {{ $t('Delivery.ClientOrders.NumCommand') }}</v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.numCommand" maxlength="30"
            hide-details persistent-placeholder variant="outlined"></v-text-field>
        </div>
      </div>
      <div v-if="false">
        <div class="col-6 justify-content-start mb-4">
          <div class="row">
            <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.ClientName') }}</v-card-title>
          </div>
          <div class="row">
            {{ clientOrder.customerDetails.name }}
            <v-text-field class="readonly-field" v-model="clientOrder.customerDetails.name" maxlength="30" hide-details
              persistent-placeholder variant="outlined"></v-text-field>
          </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
          <div class="row">
            <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.EmailClient') }}</v-card-title>
          </div>
          <div class="row">
            <v-text-field class="readonly-field" v-model="clientOrder.customerDetails.mail" maxlength="30" hide-details
              persistent-placeholder variant="outlined"></v-text-field>
          </div>
        </div>

        <div class="col-6 justify-content-start mb-4">
          <div class="row">
            <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.LocationLabel') }}</v-card-title>
          </div>
          <div class="row">
            <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.locationLabel" maxlength="30"
              hide-details persistent-placeholder variant="outlined"></v-text-field>
          </div>
        </div>

        <div class="col-6 justify-content-start mb-4">
          <div class="row">
            <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.Adresse') }}</v-card-title>
          </div>
          <div class="row">
            <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.locationAddress" maxlength="30"
              hide-details persistent-placeholder variant="outlined"></v-text-field>
          </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
          <div class="row">
            <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.PostaCode') }}</v-card-title>
          </div>
          <div class="row">
            <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.locationPostalCode"
              maxlength="30" hide-details persistent-placeholder variant="outlined"></v-text-field>
          </div>
        </div>

      </div>
      <div class="col-12 mb-4">
        <div class="delivery-route">
          <div class="header">
            <strong>{{ $t('orders.from') }}</strong>
          </div>
          <div class="row">
            <div class="column">
              <template v-if="deliveryMethod === 0 || deliveryMethod === 1">
                <div><strong>{{ $t('orders.address') }} :</strong> {{ clientOrder.supplier.address }}</div>
                <div><strong>{{ $t('orders.city') }} :</strong> {{ clientOrder.supplier.city }}</div>
                <div><strong>{{ $t('orders.country') }} :</strong> {{ clientOrder.supplier.country }}</div>
                <div><strong>{{ $t('orders.postalCode') }} :</strong> {{ clientOrder.supplier.postalCode }}</div>
              </template>
              <template v-else-if="deliveryMethod === 2">
                <div><strong>{{ $t('orders.address') }} :</strong> {{ clientOrder.pickupPoint.address }}</div>
                <div><strong>{{ $t('orders.city') }} :</strong> {{ clientOrder.pickupPoint.city }}</div>
                <div><strong>{{ $t('orders.country') }} :</strong> {{ clientOrder.pickupPoint.country }}</div>
                <div><strong>{{ $t('orders.postalCode') }} :</strong> {{ clientOrder.pickupPoint.postalCode }}</div>
                <div><strong>{{ $t('orders.contactNumber') }} :</strong> {{ clientOrder.pickupPoint.contactNumber }}
                </div>
              </template>
            </div>
          </div>

          <div class="header">
            <strong>{{ $t('orders.to') }}</strong>
          </div>
          <div class="row">
            <div class="column">
              <template v-if="deliveryMethod === 0 || deliveryMethod === 2">
                <div><strong>{{ $t('orders.clientName') }} :</strong> {{ clientOrder.customerDetails.name }}</div>
                <div><strong>{{ $t('orders.address') }} :</strong> {{ clientOrder.clientOrderDetails.locationAddress }}
                </div>
                <div><strong>{{ $t('orders.postalCode') }} :</strong> {{
                  clientOrder.clientOrderDetails.locationPostalCode }}</div>
                <div><strong>{{ $t('orders.contactNumber') }} :</strong> {{ clientOrder.customerDetails.phoneNumber }}
                </div>
              </template>
              <template v-else-if="deliveryMethod === 1">
                <div><strong>{{ $t('orders.address') }} :</strong> {{ clientOrder.pickupPoint.address }}</div>
                <div><strong>{{ $t('orders.city') }} :</strong> {{ clientOrder.pickupPoint.city }}</div>
                <div><strong>{{ $t('orders.country') }} :</strong> {{ clientOrder.pickupPoint.country }}</div>
                <div><strong>{{ $t('orders.postalCode') }} :</strong> {{ clientOrder.pickupPoint.postalCode }}</div>
                <div><strong>{{ $t('orders.contactNumber') }} :</strong> {{ clientOrder.pickupPoint.contactNumber }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">{{ $t('orders.locationMap') }}</v-card-title>
        </div>
        <div v-if="mapLoader" class="d-flex justify-center align-center" style="height: 200px;">
          <v-progress-circular indeterminate :size="30"></v-progress-circular>
        </div>
        <div v-else>
          <l-map ref="mapRef" :zoom="zoom" :center="center" style="height: 500px; width: 100%"
            @ready="fitBoundsToMarkers">
            <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; OpenStreetMap contributors" />

            <l-marker :lat-lng="pointA">
              <l-popup :visible="true">📍 {{ $t('orders.deliveryStartPoint') }}</l-popup>
            </l-marker>

            <l-marker :lat-lng="pointB">
              <l-popup>📍 {{ $t('orders.deliveryEndPoint') }}</l-popup>
            </l-marker>
          </l-map>
        </div>
      </div>
      <div v-if="!mapLoader" class="col-6 mb-4">
        <div class="row">
          <v-card-title class="text-left justify-content-center ma-0">
            {{ $t('orders.deliveryStartPoint') }}
          </v-card-title>
        </div>
        <div class="location-map-container">
          <v-btn color="primary" variant="outlined" class="mt-3" :href="mapDepartUrl" target="_blank">
            <v-icon left class="mr-2">mdi-map-marker</v-icon>
            {{ $t('orders.viewOnGoogleMaps') }}
          </v-btn>
        </div>
      </div>

      <div v-if="!mapLoader" class="col-6 mb-4">
        <div class="row">
          <v-card-title class="text-left justify-content-center ma-0">{{ $t('orders.deliveryEndPoint') }}</v-card-title>
        </div>
        <div class="location-map-container">
          <v-btn color="primary" variant="outlined" class="mt-3" :href="mapUrl" target="_blank">
            <v-icon left class="mr-2">mdi-map-marker</v-icon>
            {{ $t('orders.viewOnGoogleMaps') }}
          </v-btn>
        </div>
      </div>

      <div v-if="!mapLoader" class="col-12 mb-4">
        <div class="row">
          <v-card-title class="text-center justify-content-center ma-0">
            {{ $t('orders.DirectionOnGoogleMaps') }}
          </v-card-title>
        </div>
        <div class="location-map-container">
          <v-btn color="primary" variant="outlined" class="mt-3" :href="mapDirectionsUrl" target="_blank">
            <v-icon left class="mr-2">mdi-map-marker</v-icon>
            {{ $t('orders.viewDirectionOnGoogleMaps') }}
          </v-btn>
        </div>
      </div>

      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">
            {{ $t('Delivery.ClientOrders.productName') }}
          </v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.clientProducts[0].productName"
            maxlength="30" hide-details persistent-placeholder variant="outlined"></v-text-field>
        </div>
      </div>

      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.quantity') }}</v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.clientProducts[0].quantity"
            maxlength="30" hide-details persistent-placeholder variant="outlined"></v-text-field>
        </div>
      </div>

      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.unitprice') }}</v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.clientProducts[0].priceUnit"
            maxlength="30" hide-details persistent-placeholder variant="outlined"></v-text-field>
        </div>
      </div>

      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.Tax') }} </v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.clientProducts[0].tax" maxlength="30"
            hide-details persistent-placeholder variant="outlined"></v-text-field>
        </div>
      </div>

      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.MontantHT') }} </v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field"
            :value="clientOrder.clientOrderDetails.clientProducts[0].priceUnit * clientOrder.clientOrderDetails.clientProducts[0].quantity"
            maxlength="30" hide-details persistent-placeholder variant="outlined" readonly></v-text-field>
        </div>
      </div>

      <div class="col-6 justify-content-start mb-4">
        <div class="row">
          <v-card-title class="text-left ma-0">{{ $t('Delivery.ClientOrders.MontantTotal') }} </v-card-title>
        </div>
        <div class="row">
          <v-text-field class="readonly-field" v-model="clientOrder.clientOrderDetails.clientProducts[0].totalPrice"
            maxlength="30" hide-details persistent-placeholder variant="outlined"></v-text-field>
        </div>
      </div>
    </div>
    <div v-else class="d-flex justify-center align-center" style="height: 200px;">
      <v-progress-circular indeterminate :size="30"></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import { getClientOrderDetailsById } from "@/api/index";
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet'
export default {
  components: { LMap, LTileLayer, LMarker, LPopup },
  data() {
    return {
      deliveryItemId: this.$route.params.id,
      clientOrder: null,
      locationLatitude: "",
      locationLongitude: "",
      locationDepartLatitude: "",
      locationDepartLongitude: "",
      supplierId: null,
      supplierLocationId: null,

      zoom: 12,
      mapLoader: true
    };
  },
  created() {
    this.fetchOrderDetails();
  },
  methods: {
    fetchOrderDetails() {
      getClientOrderDetailsById(this.deliveryItemId)
        .then((response) => {
          this.clientOrder = response.data;
          this.locationLatitude = response.data.clientOrderDetails?.deliveryMethod == 1 ?
            response.data.pickupPoint.latitude
            : response.data.clientOrderDetails.latitude;
          this.locationLongitude = response.data.clientOrderDetails?.deliveryMethod == 1 ?
            response.data.pickupPoint.longitude
            : response.data.clientOrderDetails.longitude;
          this.supplierId = response.data.supplier.idSupplier;
          this.supplierLocationId = response.data.supplier.idLocation;
          this.locationDepartLatitude = response.data.clientOrderDetails?.deliveryMethod == 2 ?
            response.data.pickupPoint.latitude
            : response.data.supplier.latitude
          this.locationDepartLongitude = response.data.clientOrderDetails?.deliveryMethod == 2 ?
            response.data.pickupPoint.longitude
            : response.data.supplier.longitude
        })
        .catch((error) => {
          console.error("Failed to fetch client order details:", error);
        }).finally(() => {
          this.mapLoader = false;
        });
    },
    fitBoundsToMarkers() {
      const bounds = [this.pointA, this.pointB]
      if (this.$refs.mapRef && this.$refs.mapRef.leafletObject) {
        this.$refs.mapRef.leafletObject.fitBounds(bounds, { padding: [20, 20] })
      }
    }
  },
  computed: {
    deliveryMethod() {
      return this.clientOrder?.clientOrderDetails?.deliveryMethod
    },
    mapUrl() {
      if (!this.locationLatitude || !this.locationLongitude) return '';
      return `https://www.google.com/maps/search/?api=1&query=${this.locationLatitude},${this.locationLongitude}`;
    },
    mapDepartUrl() {
      if (!this.locationDepartLatitude || !this.locationDepartLongitude) return '';
      return `https://www.google.com/maps/search/?api=1&query=${this.locationDepartLatitude},${this.locationDepartLongitude}`;
    },
    mapDirectionsUrl() {
      if (!this.locationLatitude || !this.locationLongitude) return '';
      if (!this.locationDepartLatitude || !this.locationDepartLongitude) return '';
      return `https://www.google.com/maps/dir/${this.locationDepartLatitude},${this.locationDepartLongitude}/${this.locationLatitude},${this.locationLongitude}`;
    },
    pointA() {
      return [this.locationDepartLatitude, this.locationDepartLongitude];
    },
    pointB() {
      return [this.locationLatitude, this.locationLongitude];
    },
    center() {
      const lat1 = parseFloat(this.locationDepartLatitude);
      const lat2 = parseFloat(this.locationLatitude);
      const lon1 = parseFloat(this.locationDepartLongitude);
      const lon2 = parseFloat(this.locationLongitude);

      if ([lat1, lat2, lon1, lon2].some(val => isNaN(val))) {
        console.warn("Une ou plusieurs coordonnées ne sont pas valides");
        return [0, 0];
      }

      return [
        (lat1 + lat2) / 2,
        (lon1 + lon2) / 2,
      ];
    }
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
}

.options-card {
  border: 1px solid #e0e0e0;
  margin-bottom: 16px;
}

.variant-table {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.description-editor {
  border-radius: 4px;
}

.tags-container {
  border-radius: 4px;
}

.tags-input-container {
  max-width: 400px;
}

.tags-list {
  justify-content: center !important;
  align-items: center !important;
  min-height: 44px;
  border-radius: 4px;
}

.suggested-tags {
  padding-top: 8px;
}

.v-card-title {
  font-family: inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #5b6d8e;
  margin-left: 12px;
  padding-left: 0;
  margin-top: 0;
  padding-top: 0;
}

:deep(.v-table) {
  background: transparent !important;
}

:deep(.v-table .v-table__wrapper > table) {
  padding: 0;
}

:deep(.v-table th) {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  background: #f5f5f5;
}

:deep(.v-table td) {
  padding: 8px 16px;
}

.slider {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  flex: content;
  color: blue;
}

.map-placeholder {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  color: #666;
}

.google-maps-link {
  display: flex;
  justify-content: center;
  text-decoration: none;
}

:deep(.v-autocomplete--single .v-field--dirty:not(.v-field--focused) input) {
  opacity: 1 !important;
}

.delivery-route {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 8px;
  margin: auto;
  font-family: Arial, sans-serif;
}

.header {
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.row {
  display: flex;
  justify-content: space-between;
}

.column {
  text-align: left;
}

.spacer {
  width: 10%;
}
</style>